import { get } from 'lodash';
import { createLogger } from 'shared/services/logger';
import { download } from '../../lib/utility/helpers';
import { ImagescopeLauncher } from './ImagescopeLauncher';
import app from '../../public-api';

const logger = createLogger('UScope:extensions:imagescope-launcher');

// Exported for unit testing
export const loader = {
  name: 'us:imagescope-launcher',

  extends: 'uScope',

  canStart (uScope) {
    const settings = get(uScope, 'vilSettings.extensions.us:imagescope-launcher');
    if (!settings) {
      logger.warn('Cannot add ImageScope toolbar button because it hasn\'t been configured.');
      return false;
    }
    return uScope.toolbarCanAddButton('openImageScopeBtn');
  },

  factory (uScope) {
    // Inject a downloader; it's simpler to test this way...
    return new ImagescopeLauncher(uScope, {download});
  }
};

app.plugins.register(loader);



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/imagescope-launcher/imagescope-launcher-loader.js